module.exports = __webpack_public_path__ + "img/ferdi.7f47d52c.jpg";